import Common from "../../Common";

export interface CompanyCombiFetch {
	dids?: {
		id: id
		number: string
		e164: string
		type: "fixed" | "cell"
		pbx_destination_id: id
		name: string
		pbx_user_id: id
	}[]
	queues?: CompanyCombiFetchQueue[]
	users?: CompanyCombiFetchUser[]
	ivrs?: CompanyCombiFetchIvr[]
	[key: string]: any
}

export type CompanyCombiFetchUser = User

export interface CompanyCombiFetchIvr {
	id: id
	name: id
	pbx_company_id: id
	pbx_user_id: id	| null
	items: CompanyCombiFetchIvrItem[]
}

export interface CompanyCombiFetchIvrItem {
	id: id
	pbx_app_ivr_id: id
	selection: id
	pbx_destination_id: id
}

export interface CompanyCombiFetchQueue {
	id: id
	name: id
	maxlen: string
	strategy: string
	pbx_queue_number: string
	pbx_name: string
	pbx_queue_type: string
	pbx_priority: null | string
	service_level_time: string
	pbx_omnigroup_id: id
}

interface Get {
	browse_users?: ("status" | "extra")[]
	browse_queues?: ("members")[]
	browse_devices?: []
	browse_ringgroups?: []
	browse_dids?: []
	browse_cids?: []
	browse_departments?: []
	browse_destinations?: []
	browse_profiles?: []
	browse_webull?: ["subscriptions"] | ["services"] | ["subscriptions", "services"]
	browse_ivrs?: ["personal"] | ["items"] | ["personal", "items"]
}

const CombiFetch = class extends Common {
	parseParams = (get: Get): string =>
		Object.entries(get)
		.flatMap(([ key, value ]) => {
			if (value && value.length > 0) {
				return value.map((item: string) => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`)
			} else {
				return [ `${encodeURIComponent(key)}[]=` ]
			}
		})
		.join('&')

	browse = (companyId: id, get: Get): CustomResponse<CompanyCombiFetch> =>
		this.get(`/company/${companyId}/combifetch?${this.parseParams(get)}`)
}

export default CombiFetch
